var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"test"},[_vm._v(_vm._s(_vm.msg))]),_c('el-input',{attrs:{"placeholder":""},model:{value:(_vm.msg),callback:function ($$v) {_vm.msg=$$v},expression:"msg"}}),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.changeMsg}},[_vm._v("test")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }